import { Link } from "react-router-dom";
import { ArrowLeft, Check } from "lucide-react";
import SEO from "@/components/SEO";
import { FadeUp } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

const DankeAnfrage = () => (
  <div data-testid="danke-page">
    <SEO
      title="Vielen Dank für eure Anfrage | Freie Trauung Deluxe"
      description="Wir haben eure Nachricht erhalten und melden uns persönlich bei euch."
      path="/danke-anfrage"
      noindex
    />
    <section className="flex min-h-[85svh] items-center justify-center px-5 py-32">
      <FadeUp className="w-full max-w-xl text-center">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-moss text-creme">
          <Check size={26} />
        </span>
        <h1 className="mt-8 font-serif text-4xl leading-[1.1] sm:text-5xl">
          Vielen Dank für eure Anfrage.
        </h1>
        <p className="mx-auto mt-6 max-w-md text-lg leading-relaxed text-stone">
          Wir haben eure Nachricht erhalten und melden uns persönlich bei euch.
        </p>
        <p className="mt-8 font-accent text-2xl italic leading-snug text-rust">
          Bis bald,<br />Marc &amp; Angela
        </p>
        <p className="mt-8 text-sm text-stone">
          Ganz dringend? Ruft uns einfach an:{" "}
          <a
            href={CONTACT.phoneHref}
            data-testid="danke-phone-link"
            className="font-semibold text-moss"
          >
            {CONTACT.phone}
          </a>
        </p>
        <Link
          to="/"
          data-testid="danke-back-link"
          className="mt-10 inline-flex items-center gap-3 rounded-full border border-sand px-8 py-4 text-sm font-bold text-ink transition-colors duration-300 hover:border-moss hover:text-moss"
        >
          <ArrowLeft size={15} /> Zurück zur Startseite
        </Link>
      </FadeUp>
    </section>
  </div>
);

export default DankeAnfrage;
